/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from core/schemas/ObjectPoolTypes.yaml
import { ToJsonConfiguration } from '../common/JsonSerializationTypes';
/**
Profile info of a reference-counted stored object.
*/
export class RefCountedObjectProfile {
    /** @param source {@displayType `DeepPartial<RefCountedObjectProfile>`} */
    constructor(source = {}) {
        /**
          Number of strong references associated with the object. The strong reference count increases when a new instance of a platform ImageRef class is created from the object's unique ID and decreases when the ImageRef instance is destroyed.
          
          Default is 0
          */
        this.strongReferences = 0;
        /**
          Number of serialized references to the object. The serialized reference count increases when an ImageRef is written to JSON or a Parcel on Android and decrease when the respective JSON or Parcel is deserialized.
          
          Default is 0
          */
        this.serializedReferences = 0;
        if (source.uniqueId !== undefined) {
            this.uniqueId = source.uniqueId;
        }
        else {
            throw new Error('uniqueId must be present in constructor argument');
        }
        if (source.timestampCreated !== undefined) {
            this.timestampCreated = source.timestampCreated;
        }
        else {
            throw new Error('timestampCreated must be present in constructor argument');
        }
        if (source.strongReferences !== undefined) {
            this.strongReferences = source.strongReferences;
        }
        if (source.serializedReferences !== undefined) {
            this.serializedReferences = source.serializedReferences;
        }
    }
    serialize(config = new ToJsonConfiguration()) {
        return {
            uniqueId: this.uniqueId,
            timestampCreated: this.timestampCreated,
            strongReferences: this.strongReferences,
            serializedReferences: this.serializedReferences,
        };
    }
}
//# sourceMappingURL=ObjectPoolTypes.js.map